<div nz-row class="full-width">
  <div nz-col nzSpan="24" class="no-form title">
    <h1>{{ title }}</h1>
  </div>
</div>

<nz-spin class="full-width" nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
  <div class="centered-box-vertical extralarge">
    <!-- ------------------- Carta identità ------------------------  -->
    <div nz-row class="full-width" nzJustify="space-between" nzAlign="top" [nzGutter]="48">
      <h1 class="login noCentered first"> Documenti di riconoscimento</h1>
      <div nz-col [nzSpan]="6">
        <p> Fronte carta d'identità</p>
        <div class="clearfix">
          <nz-upload nzListType="picture-card" [(nzFileList)]="fileListCiF" [nzShowButton]="fileListCiF.length < 1"
            [nzPreview]="handlePreview" nzFileType="application/pdf,image/jpeg" nzAccept="application/pdf,image/jpeg"
            [nzBeforeUpload]="beforeUploadCIFront" [nzRemove]="removeCIFront">
            <div>
              <i nz-icon nzType="idcard"></i>
              <div class="uploadDocument">Fronte Carta di Identità in formato PDF o JPEG</div>
            </div>
          </nz-upload>
          <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContentCiF" [nzFooter]="null"
            (nzOnCancel)="previewVisible = false">
            <ng-template #modalContentCiF>
              <img [src]="previewImage" class="full-width" />
            </ng-template>
          </nz-modal>
        </div>
      </div>

      <div nz-col [nzSpan]="6">
        <p> Retro carta d'identità</p>
        <div class="clearfix">
          <nz-upload nzListType="picture-card" [(nzFileList)]="fileListCiR" [nzShowButton]="fileListCiR.length < 1"
            [nzPreview]="handlePreview" nzFileType="application/pdf,image/jpeg" nzAccept="application/pdf,image/jpeg"
            [nzBeforeUpload]="beforeUploadCIRear" [nzRemove]="removeCIRear">
            <div>
              <i nz-icon nzType="idcard"></i>
              <div class="uploadDocument">Retro Carta di Identità in formato PDF o JPG</div>
            </div>
          </nz-upload>
          <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContentCiR" [nzFooter]="null"
            (nzOnCancel)="previewVisible = false">
            <ng-template #modalContentCiR>
              <img [src]="previewImage" class="full-width" />
            </ng-template>
          </nz-modal>
        </div>
      </div>
    <!-- ------------------- Codice fiscale ------------------------  -->
      <div nz-col [nzSpan]="6">
        <div class="clearfix">
          <p> Fronte codice fiscale</p>
          <nz-upload nzListType="picture-card" [(nzFileList)]="fileListCfF" [nzShowButton]="fileListCfF.length < 1"
            [nzPreview]="handlePreview" nzFileType="application/pdf,image/jpeg" nzAccept="application/pdf,image/jpeg"
            [nzBeforeUpload]="beforeUploadCFFront" [nzRemove]="removeCFFront">
            <div>
              <i nz-icon nzType="credit-card"></i>
              <div class="uploadDocument">Fronte codice fiscale in formato PDF o JPG</div>
            </div>
          </nz-upload>
          <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContentCfF" [nzFooter]="null"
            (nzOnCancel)="previewVisible = false">
            <ng-template #modalContentCfF>
              <img [src]="previewImage" class="full-width" />
            </ng-template>
          </nz-modal>
        </div>
      </div>

      <div nz-col [nzSpan]="6">
        <div class="clearfix">
          <p> Retro codice fiscale</p>
          <nz-upload nzListType="picture-card" [(nzFileList)]="fileListCfR" [nzShowButton]="fileListCfR.length < 1"
            [nzPreview]="handlePreview" nzFileType="application/pdf,image/jpeg" nzAccept="application/pdf,image/jpeg"
            [nzBeforeUpload]="beforeUploadCFRear" [nzRemove]="removeCFRear">
            <div>
              <i nz-icon nzType="credit-card"></i>
              <div class="uploadDocument">Retro Codice fiscale in formato PDF o JPG</div>
            </div>
          </nz-upload>
          <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContentCfR" [nzFooter]="null"
            (nzOnCancel)="previewVisible = false">
            <ng-template #modalContentCfR>
              <img [src]="previewImage" class="full-width" />
            </ng-template>
          </nz-modal>
        </div>
      </div>
    </div>
<!-- ------------------- Contratto & Consenso firmato ------------------------  -->
    <h1 class="login noCentered with-margin-bottom"> Contratto, consenso e codice controllo</h1>
    <div nz-row class="full-width" nzJustify="space-between" nzAlign="top" nzGutter="48">
      <div nz-col nzSpan="6">
        <p class="description">Scaricare il <b>Modulo di Richiesta Adesione SPID</b> da sottoporre alla firma del richiedente dell'identità digitale.</p>
        <div class="aligned-button">
          <button nz-button class="submit" nzType="primary" nzShape="circle" (click)="onDownloadContract()" nzSize="default" download>
            <i nz-icon nzType="download"></i>Scarica il documento
          </button>
        </div>
      </div>
      <div nz-col nzSpan="6">
        <p class="description">Caricare il documento <b>firmato</b> dal richiedente dell'identità digitale dopo averne appurata la corretta compilazione.</p>
        <div class="clearfix">
          <nz-upload nzListType="picture-card" [(nzFileList)]="fileListContract" [nzShowButton]="fileListContract.length < 1"
            [nzPreview]="handlePreview" nzFileType="application/pdf,image/jpeg" nzAccept="application/pdf,image/jpeg"
            [nzBeforeUpload]="beforeUploadContract" [nzRemove]="removeContract" [nzDisabled]="!isContractDownloaded">
            <div>
              <i nz-icon nzType="audit"></i>
              <div class="uploadDocument">Contratto <b>firmato</b> in formato PDF o JPG</div>
            </div>
          </nz-upload>
          <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContentContract" [nzFooter]="null"
            (nzOnCancel)="previewVisible = false">
            <ng-template #modalContentContract>
              <img [src]="previewImage" class="full-width" />
            </ng-template>
          </nz-modal>
        </div>
      </div>
      <div nz-col nzSpan="6">
        <p class="description">Caricare il documento <b>firmato</b> attestante il <b>consenso dell'organizzazione</b> al rilascio dell'identità al dipendente/collaboratore richiedente.</p>
        <div class="clearfix">
          <nz-upload nzListType="picture-card" [(nzFileList)]="fileListConsent" [nzShowButton]="fileListConsent.length < 1"
            [nzPreview]="handlePreview" nzFileType="application/pdf,image/jpeg" nzAccept="application/pdf,image/jpeg"
            [nzBeforeUpload]="beforeUploadConsent" [nzRemove]="removeConsent">
            <div>
              <i nz-icon nzType="team"></i>
              <div class="uploadDocument">Consenso <b>firmato</b> in formato PDF o JPG</div>
            </div>
          </nz-upload>
          <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContentConsent" [nzFooter]="null"
            (nzOnCancel)="previewVisible = false">
            <ng-template #modalContentConsent>
              <img [src]="previewImage" class="full-width" />
            </ng-template>
          </nz-modal>
        </div>
      </div>
      <div nz-col nzSpan="6">
        <p class="description">Inserire un <b>codice di controllo</b> scelto dal richiedente SPID. Il codice di controllo deve essere costituito da tre caratteri numerici non identici.</p>
        <form class="aligned-button" nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="approveRequest()">
          <nz-form-item>
            <nz-form-control nzHasFeedback [nzValidateStatus]="validateForm.get('controlCode')" [formGroup]="validateForm" nzErrorTip="Inserire un codice di controllo valido">
              <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="controlCodeTemplate">
                <input [type]="controlCodeVisible ? 'text' : 'password'" nz-input name="controlCode" placeholder="Codice di controllo"
                  formControlName="controlCode" autocomplete="off"/>
              </nz-input-group>
              <ng-template #controlCodeTemplate>
                <i nz-icon [nzType]="controlCodeVisible ? 'eye-invisible' : 'eye'"
                  (click)="controlCodeVisible = !controlCodeVisible"></i>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>
    </div>
    <div nz-row class="full-width approve-button" nzJustify="end" nzAlign="top">
      <div nz-col nzSpan="4">
        <button class="submit" nz-button nzType="primary" (click)="approveRequest()" [disabled]="!canActivateApproveButton"> Approva </button>
      </div>
    </div>
  </div>

</nz-spin>
